// extracted by mini-css-extract-plugin
export default {"video":"video__YimbN","wrapper":"wrapper__yZx5Q","modal":"modal__+Wl79","modal-close":"modal-close__vP-Ax","disable-scroll":"disable-scroll__1wETs"};